<template>
  <div class="d-inline-flex align-items-center gap-2">
    <button
      type="button"
      class="btn btn-sm btn-outline-secondary"
      aria-label="Previous month"
      @click="step(-1)"
    >
      <font-awesome-icon icon="fa-solid fa-chevron-left" />
    </button>
    <MonthPickerComponent
      v-model="picked"
      :min="`${firstYear}-01`"
      :max="`${lastYear}-12`"
      ariaLabel="Month"
      class="month-picker"
    />
    <button
      type="button"
      class="btn btn-sm btn-outline-secondary"
      aria-label="Next month"
      @click="step(1)"
    >
      <font-awesome-icon icon="fa-solid fa-chevron-right" />
    </button>
  </div>
</template>

<script setup lang="ts">
import MonthPickerComponent from "@/components/common/MonthPickerComponent.vue";
import { computed } from "vue";

const year = defineModel<number>("year", { required: true });
const month = defineModel<number>("month", { required: true });

const currentYear = new Date().getFullYear();
const firstYear = currentYear - 5;
const lastYear = currentYear + 1;

// The picker speaks `YYYY-MM`; this component's models stay a year and a month number.
const picked = computed({
  get: () => `${year.value}-${String(month.value).padStart(2, "0")}`,
  set: (value: string) => {
    if (value === "") return;
    const [pickedYear, pickedMonth] = value.split("-").map(Number);
    year.value = pickedYear;
    month.value = pickedMonth;
  },
});

const step = (delta: number): void => {
  let nextMonth = month.value + delta;
  let nextYear = year.value;
  if (nextMonth > 12) {
    nextMonth = 1;
    nextYear += 1;
  } else if (nextMonth < 1) {
    nextMonth = 12;
    nextYear -= 1;
  }
  year.value = nextYear;
  month.value = nextMonth;
};
</script>

<style lang="scss" scoped>
.month-picker {
  width: 11rem;
}
</style>
